import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component({})
export default class FlowchartNode extends Vue {
	@Prop()
	public id?: number;

	@PropSync('x', { default: 0 })
	public localX?: number;

	@PropSync('y', { default: 0 })
	public localY?: number;

	@PropSync('topConnector', { default: null })
	public localTopConnector?: number;

	@PropSync('bottomConnector', { default: null })
	public localBottomConnector?: number;

	@Prop({ default: '' })
	public type?: string;

	@Prop({ default: '' })
	public label?: string;

	@Prop({ default: '' })
	public subLabel?: string;

	@Prop({ default: { centerX: 0, centerY: 0, scale: 1 } })
	public options: any;

	@Prop()
	public disabled?: boolean;

	public get nodeStyle() {
		return {
			// @ts-ignore
			top: this.options.centerY + this.localY * this.options.scale + 'px', // remove: this.options.offsetTop +
			// @ts-ignore
			left: this.options.centerX + this.localX * this.options.scale + 'px', // remove: this.options.offsetLeft +
			transform: `scale(${this.options.scale})`,
		};
	}

	public handleMousedown(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		const target = e.target || e.srcElement;
		if (target.className.indexOf('node-input') < 0 && target.className.indexOf('node-output') < 0) {
			this.$emit('nodeSelected', e);
		}
	}

	public outputMouseDown(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		this.$emit('linkingStart');
	}

	public inputMouseDown(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
	}

	public inputMouseUp(e: any) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		this.$emit('linkingStop');
	}
}
